import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20lifestyle%20editorial%20with%20warm%20terracotta%20and%20cream%20toned%20textiles%20artfully%20draped%20on%20a%20natural%20linen%20surface%2C%20soft%20diffused%20daylight%20creating%20gentle%20shadows%2C%20organic%20textures%20with%20cotton%20and%20wool%20fabrics%2C%20clean%20aesthetic%20with%20subtle%20warmth%2C%20peaceful%20and%20inviting%20atmosphere%2C%20editorial%20product%20photography%20style%2C%20no%20people&width=1600&height=900&seq=hero-bg-itaobuy-2026-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet guida prodotti moda italiana"
          title="Itaobuy Spreadsheet guida completa prodotti"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          {t('hero.title', "Itaobuy Spreadsheet: La Guida Italiana Numero 1 nel 2026")}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          {t('hero.subtitle', "Trova, confronta e analizza migliaia di prodotti con guide dettagliate, informazioni aggiornate e consigli creati per utenti italiani.")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-lg bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            {t('buttons.itaobuySheet', 'itaobuy sheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 rounded-lg bg-white/90 text-foreground-900 text-base font-semibold hover:bg-white transition-all hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            {t('buttons.buyItNow', 'buy it now')}
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8">
          {['trustBadge1', 'trustBadge2', 'trustBadge3', 'trustBadge4'].map((key) => (
            <span key={key} className="flex items-center gap-2 text-white/80 text-xs md:text-sm whitespace-nowrap">
              <span className="w-5 h-5 flex items-center justify-center text-accent-300">
                <i className="ri-checkbox-circle-fill text-sm"></i>
              </span>
              {t(`hero.${key}`, '')}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </span>
      </div>
    </section>
  );
}